import { h } from "../../core/dom.js";
import { entryTitle, groupByArea, markSeen } from "../../dev/changelog.js";
import { swipeToClose } from "./sheet.js";

export function changelogSheet(app, entry, { onClose = () => {} } = {}) {
  const backdrop = h("div", { class: "sheet-backdrop" });
  const close = () => {
    markSeen(entry, app.config.version);
    backdrop.remove();
    swipe?.detach();
    release?.();
    onClose();
  };
  const list = h("div", { class: "changelog-list" },
    groupByArea(entry).map(([area, changes]) => h("section", {},
      h("h3", {}, area),
      h("ul", {}, changes.map((change) => h("li", {},
        h("p", {}, change.testo),
        change.come_provare ? h("p", { class: "fineprint" }, `Come provarlo: ${change.come_provare}`) : null))))));
  const sheet = h("section", { class: "sheet", role: "dialog", "aria-modal": "true", "aria-label": "Novità di questa versione" },
    h("button", { class: "sheet-close", "aria-label": "Chiudi", type: "button", onclick: close }, "✕"),
    h("div", { class: "sheet-handle" }),
    h("h2", {}, entryTitle(entry, app.config.version)),
    list,
    h("button", { class: "btn btn-primary wide", type: "button", onclick: close }, "Ho visto"));
  backdrop.addEventListener("click", (event) => { if (event.target === backdrop) close(); });
  backdrop.append(sheet);
  document.body.append(backdrop);
  const swipe = swipeToClose(sheet, { onClose: close, scroller: list });
  const release = app.back?.push(() => {
    markSeen(entry, app.config.version);
    backdrop.remove();
    onClose();
  });
  return { element: backdrop, close };
}
